import {
    SET_LOADING,SET_INVOICES_TOTAL,SET_INVOICE,SET_INVOICES
} from "./mutations";
import ApiService from "@/core/services/ApiService";

export default {
  async fetchMgmtInvoiceForms({ commit },  params = {}) {
    commit(SET_LOADING, true);
    ApiService.setHeader();
    return await ApiService.query("mgmt/invoices",params)
        .then((result) => {
          result =result.data;
          commit(SET_INVOICES, result?.data ?? []);
          commit(SET_INVOICES_TOTAL, result?.total ?? []);
          commit(SET_LOADING, false);

          return result;
        })
        .catch(({response}) => {
          // console.log('error response', response);
          commit(SET_LOADING, false);
        });
  },
  async fetchMgmtInvoiceForm({ commit }, id) {
    commit(SET_LOADING, true);
    ApiService.setHeader();
    return await ApiService.get(`mgmt/invoices/${id}`)
        .then((result) => {
          commit(SET_INVOICE, result?.data ?? {});
          commit(SET_LOADING, false);
          return result;
        })
        .catch(({response}) => {
          // console.log('error response', response);
          commit(SET_INVOICE, { success: false });

        });
  },
  async updateMgmtInvoiceForm({ commit }, params) {
    commit(SET_LOADING, true);
    ApiService.setHeader();
    return await ApiService.put("mgmt/invoices/"+params.apply_form_id, params)
        .then((result) => {
          result = result.data;

          return result;
        })
        .catch(({response}) => {
          // console.log('error response', response.data);
          return response.data;
        });
  },
  async updateMgmtInvoiceDesc({ commit }, params) {
    commit(SET_LOADING, true);
    ApiService.setHeader();
    return await ApiService.put("mgmt/invoices/"+params.id+"/update_approve_desc", params)
        .then((result) => {
            result = result.data;

            return result;
        })
        .catch(({response}) => {
            // console.log('error response', response.data);
            return response.data;
        });
  },
};
